/**
 * Ollie's latest reply is still on its way or typing out: the thread's
 * follow-up chips and "This isn't right" wait until it has finished.
 * `revealHold` is set when a send starts and cleared when the reply has
 * typed out (or no new reply came), so the chips never flash in between
 * the reply landing and its typing starting.
 */
export const isOllieReplyRevealing = ({
  isSending = false,
  revealHold = null,
  animatingMessageId = null,
  messages = [],
} = {}) => {
  if (isSending) return true
  if (!revealHold) return false
  if (!animatingMessageId) return true
  // A reply that has left the thread (new thread, venue switch) can't hold the chips back.
  return (Array.isArray(messages) ? messages : []).some(
    message => message?.id === animatingMessageId,
  )
}

/** Only the newest Ollie reply keeps its action buttons. */
export const latestOllieReplyId = (messages = []) => {
  const list = Array.isArray(messages) ? messages : []
  for (let index = list.length - 1; index >= 0; index -= 1) {
    if (list[index]?.role === 'assistant') return list[index].id ?? null
  }
  return null
}

/**
 * A thread that opens with messages already in it (reused Why?, the hero's
 * Ask Ollie, reopening the panel) shows its latest reply, not the first
 * message: Ollie's newest reply, else the last message. Null when empty.
 */
export const ollieReopenScrollTargetId = (messages = []) => {
  const list = Array.isArray(messages) ? messages : []
  if (!list.length) return null
  return latestOllieReplyId(list) ?? list[list.length - 1]?.id ?? null
}
